import { render } from "./cpt-img-quota.vue?vue&type=template&id=f5e0dc6e&scoped=true"
import script from "./cpt-img-quota.vue?vue&type=script&lang=js"
export * from "./cpt-img-quota.vue?vue&type=script&lang=js"

import "./cpt-img-quota.vue?vue&type=style&index=0&id=f5e0dc6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e0dc6e"]])

export default __exports__